import { render } from "./SuccessAnimation.vue?vue&type=template&id=47e06a3d&scoped=true"
import script from "./SuccessAnimation.vue?vue&type=script&lang=js"
export * from "./SuccessAnimation.vue?vue&type=script&lang=js"

import "./SuccessAnimation.vue?vue&type=style&index=0&id=47e06a3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e06a3d"]])

export default __exports__